<div class="max-w-[1060px] mx-auto">
  <div class="block p-6 text-center">
    <h1 class="text-3xl text-orange-800 font-bold mb-6">Stránka nenalezena</h1>
    <h2 class="text-black font-bold mb-6">Omlouváme se, ale požadovaná stránka není k dispozici.</h2>
    <la-icon icon="sad-tear" size="10x"></la-icon>
  </div>
</div>
